import { BUSINESS_APP_ORIGIN } from '../constants/constants';

export const getBIReportData = (
  evid: number,
  tabName: string,
  biParams: Object,
) => {
  return {
    evid,
    panel_id: 'my_business_panel',
    tab_name: tabName,
    ...biParams,
  };
};

export const getBusinessAppOrigin = (appDefId: string) =>
  BUSINESS_APP_ORIGIN + '-' + appDefId;

export const isBusinessAppOrigin = (origin: string) =>
  origin.includes(BUSINESS_APP_ORIGIN);

export const getAppDefIdFromBusinessAppOrigin = (origin: string): string => {
  return origin.replace(`${BUSINESS_APP_ORIGIN}-`, '');
};
